import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

const styled = withStyles(theme => {
  return {
    container: {}
  };
});

class TabLocation extends React.Component {
  render() {
    const { data } = this.props;

    console.log(data);

    const lat = data.location.coordinates[1];
    const lon = data.location.coordinates[0];

    const url = `https://maps.google.com/maps?q=${lat},${lon}&hl=es;z=14&output=embed&zoom=20`;

    return (
      <iframe
        title="User Location"
        width="100%"
        height="400"
        frameBorder="0"
        scrolling="no"
        marginHeight="0"
        marginWidth="0"
        src={url}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.userProfile.data
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {}
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(styled(TabLocation))
);
